import {useCookieConsentStore} from "~/stores/cookieConsent/index.js";

export const useCookieConsent = () => {
    const store = useCookieConsentStore()

    // Initialiser au montage
    onMounted(() => {
        store.initializeFromCookies()
    })

    // Méthodes utilitaires
    const trackEvent = (eventName, parameters = {}) => {
        if (store.canUseAnalytics && window.gtag) {
            window.gtag('event', eventName, parameters)
        }
    }

    const canLoadScript = (scriptType) => {
        return store.isCookieTypeAllowed(scriptType)
    }

    return {
        // State
        ...storeToRefs(store),

        // Actions
        ...store,

        // Utils
        trackEvent,
        canLoadScript
    }
}